import { AxiosInstance } from 'axios';
import { getIdToken, onAuthStateChanged } from 'firebase/auth';
import { jwtDecode } from 'jwt-decode';
import { v4 as uuidv4 } from 'uuid';

function setTokenOnHeader(axiosInstance: AxiosInstance, auth: any, token: string) {
  const accessToken = 'Bearer ' + token;
  axiosInstance.defaults.headers.common['Authorization'] = accessToken;
  axiosInstance.defaults.headers.common['X-Bubbletap-Context'] = uuidv4();
  axiosInstance.defaults.headers.common['X-Bubbletap-Device'] = auth?.currentUser?.uid ?? '';
}

const getIdTokenPromise = async ({
  auth,
  axiosInstance,
  cookieDomain,
}: {
  auth: any;
  axiosInstance: AxiosInstance;
  cookieDomain: string;
}): Promise<string> => {
  return new Promise((resolve, reject) => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      unsubscribe();
      if (user) {
        getIdToken(user).then(
          (idToken) => {
            setTokenOnHeader(axiosInstance, auth, idToken);
            const decoded = jwtDecode(idToken);
            document.cookie = `exp=${decoded.exp}; path=/`;
            document.cookie = `auth_token=${idToken}; domain=${cookieDomain}; path=/; max-age=3600; secure`; // 1시간 유효
            resolve(idToken);
          },
          (error) => {
            reject({ error: error });
            document.cookie = `auth_token=; domain=${cookieDomain}; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
          }
        );
      } else {
        console.log('no user');
        localStorage.removeItem('isCustomLogin');
        // setLoading(false);
        return reject({
          response: { status: 404 },
          config: { useRedirectAndLogout: true, useData: true },
        });
      }
    });
  });
};

export { getIdTokenPromise, setTokenOnHeader };
